module.exports = __webpack_public_path__ + "img/serve_02@2x.46cb8e75.png";